import api from './api';
/**
 * @description 获得所有公告列表
 * @augments morgan
 * @param {Integer} pageNo 页码
 * @param {Integer} pageSize 页大小
 * @param {Integer} type 0普通公告;1招标公告;2备案告知;3招标动态;4政策法规
 */
export function bidList(pageNo, pageSize, type) {
  let params = {
    pageNo: pageNo,
    pageSize: pageSize,
    bidsType: type
  }
  return api.post('/bids/getBidsList', params, true, false);
}
/**
 * @description 获得具体公告信息
 * @augments morgan
 * @param {Integer} bidsId 公告ID
 */
export function bidInfo(bidsId) {
  let params = {
    bidsId: bidsId
  }
  return api.post('/bids/getBids', params, true, false);
}



// WEBPACK FOOTER //
// ./src/api/frontApi/bidding.js